import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const BarChartContent = ({ data, title, customTitle, elementId, elementName, responsive = false, divisor = true }) => {

    useEffect(() => {
        if (!data?.length) return;

        const labels = [];
        const values = [];

        data.forEach((element) => {
            labels.push(element?.text ?? element?.type ?? element?.stolen_item_day ?? '');
            values.push(Number(element?.qty) || 0);
        });

        GraphicUtils.barChart(elementId, values.slice(0, 10), labels.slice(0, 10), false);
        if (labels.length > 0) ReportUtils.createExportableTable(labels, values, customTitle ?? title, null, [elementName ?? "Descrição", 'Quantidade']);
    }, [data, elementId, title]);

    return (
        <>
            <div className={responsive ? 'chart-report duo-bar-chart' : 'chart-report'}>
                <span className="chart-title">{title} {data?.length >= 10 ? ` (TOP 10)` : ""}</span>
                <div className="mt-1" id={elementId}></div>
            </div>

            {!responsive && divisor && <div className="chart-divisor"/>}
        </>
    );
};

export default BarChartContent;